<script setup>
import {onMounted, ref} from "vue";

const props = defineProps({
  isShowSorting: {
    type: Boolean,
    required: true,
    default: false
  },
  currentSortingColumn: {
    type: [String, null],
    required: true,
    default: () => null
  },
  currentSortingOrder: {
    type: String,
    required: true,
    default: () => "asc"
  },
  currentColumn: {
    type: String,
    required: true
  }
});

const emit = defineEmits(["change-sorting"]);

const columnSortingOrder = ref(null);

const setSortingOrder = (value) => {
  columnSortingOrder.value = value;
  const columnName = columnSortingOrder.value === null ? null : props.currentColumn
  emit("change-sorting", {column: columnName, order: columnSortingOrder.value});
};

onMounted(() => {
  if (props.currentSortingColumn === props.currentColumn) {
    columnSortingOrder.value = props.currentSortingOrder;
  } else {
    columnSortingOrder.value = null;
  }
});

</script>

<template>
  <div
    v-if="isShowSorting"
    class="sorting-box"
  >
    <div
      class="sorting-box__item"
      :class="{'sorting-box__item--active': columnSortingOrder === null}"
      @click="setSortingOrder(null)"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.33305 11H8.99976M2.33309 7L11.9998 7M2.33301 3H5.99976"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      по умолчанию
    </div>
    <div
      class="sorting-box__item"
      :class="{'sorting-box__item--active': columnSortingOrder === 'asc'}"
      @click="setSortingOrder('asc')"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.3335 6.99999L9.00024 7M2.33358 11L12.0002 11M2.33358 3L6.00024 3"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      от А до Я
    </div>
    <div
      class="sorting-box__item"
      :class="{'sorting-box__item--active': columnSortingOrder === 'desc'}"
      @click="setSortingOrder('desc')"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.3335 7L9.00008 7M2.33358 11H6.00016M2.33358 3L12.0002 3"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      от Я до А
    </div>
  </div>
</template>

<style scoped lang="scss">
.sorting-box {
  position: absolute;
  top: 100%;

  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #FFFFFF;
  border-radius: 8px;
  box-shadow: 1px 2px 10px 0 #131E2726;
  z-index: 2000;
  padding: 10px;
  cursor: auto;

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #373D3F;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    user-select: none;
    border-radius: 8px;
    padding: 6px 14px;

    &--active {
      color: #1F9AFF;
    }

    &:hover {
      background-color: #EEF1F4;
    }
  }
}
</style>